import styled from '../../../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import { variables } from '@indriver/yrel';
import preset from './preset.js';

var style = getPresets(preset, {
  color: 'accent'
});

var getColor = function getColor(props) {
  if (props.design === 'default' && props.accent !== 'both') {
    return variables['text-and-icon-secondary'];
  }

  return style.color(props);
};

var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "btu1h8r",
  vars: {
    "btu1h8r-0": [style.fontSize],
    "btu1h8r-1": [style.lineHeight],
    "btu1h8r-2": [getColor]
  }
});

export { Box };


require('../../../../styles-linaria/cell/components/cell-secondary-text/cell-secondary-text.styles.css');
